import { render, staticRenderFns } from "./crabon2.vue?vue&type=template&id=216c4028&scoped=true&"
import script from "./crabon2.vue?vue&type=script&lang=js&"
export * from "./crabon2.vue?vue&type=script&lang=js&"
import style0 from "./crabon2.vue?vue&type=style&index=0&id=216c4028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216c4028",
  null
  
)

export default component.exports